import StoreSpeedOfService from './StoreSpeedOfService';
export default StoreSpeedOfService;